import React from 'react';

/**
 * renderTextWithLineBreaks converts line breaks into React paragraph elements
 * @param text - The text to render
 * @param baseClassName - Base CSS class for all paragraphs
 * @param gapClassName - CSS class for spacing between paragraphs (applied to all except the first)
 * @param emptyLineSpaceChar - Character to use to maintain empty lines
 * @returns Array of React elements
 */
export const renderTextWithLineBreaks = (
  text: string | undefined | null,
  baseClassName = '',
  gapClassName = '',
  emptyLineSpaceChar = '\u00A0',
): React.ReactNode | null => {
  if (!text) return null;

  // Split text by line breaks
  const paragraphs = text.split('\n');

  return paragraphs.map((paragraph, index) => (
    <p key={index} className={`${baseClassName} ${index > 0 ? gapClassName : ''} whitespace-pre-line`}>
      {paragraph || emptyLineSpaceChar} {/* Use non-breaking space if paragraph is empty */}
    </p>
  ));
};

/**
 * Converts a string to title case by capitalizing the first letter of each word.
 * @param input - The input string to convert
 * @returns A new string in title case format
 */
export const toTitleCase = (input = ''): string => {
  return input
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
